import PropTypes from 'prop-types'

import { ReactComponent as InfoCircleIcon } from '../../assets/images/common/icons/info-circle-icon.svg'
import './FieldInfo.scss'

const FieldInfo = ({ message }) => {
  return (
    <div id='FieldInfo'>
      <div className='info-container w-100 p-2 d-flex align-items-center justify-content-start'>
        <InfoCircleIcon id='infoCircleIcon' aria-hidden='true'/>
        <p className='w-100'>{message}</p>
      </div>
    </div>
  )
}

FieldInfo.propTypes = {
  message: PropTypes.string,
}

export default FieldInfo
